export type AesEncodeFn = (secret: string, iv: string) => (data: string) => Promise<string>;

const BASE64_CHUNK_SIZE = 0x8000;

function base64ToBytes(base64: string): Uint8Array {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
}

function bytesToBase64(bytes: Uint8Array): string {
    let binary = "";

    for (let i = 0; i < bytes.length; i += BASE64_CHUNK_SIZE) {
        const chunk = bytes.subarray(i, i + BASE64_CHUNK_SIZE);
        binary += String.fromCharCode(...chunk);
    }

    return btoa(binary);
}

export const aesEncodeFn: AesEncodeFn =
    (secret, iv) => async data => {
        const encoder = new TextEncoder();

        const keyBytes = base64ToBytes(secret);
        const cryptoKey = await crypto.subtle.importKey(
            "raw",
            keyBytes,
            { name: "AES-GCM" },
            false,
            ["encrypt"]
        );

        const ivBytes = base64ToBytes(iv);
        const plaintext = encoder.encode(data);

        const ciphertextBuffer = await crypto.subtle.encrypt(
            { name: "AES-GCM", iv: ivBytes },
            cryptoKey,
            plaintext
        );

        return bytesToBase64(new Uint8Array(ciphertextBuffer));
    };